var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSofaBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0312 12.2031C22.6832 12.2031 22.3493 12.3414 22.1032 12.5875C21.857 12.8337 21.7188 13.1675 21.7188 13.5156V14.8281C21.7188 15.0022 21.6496 15.1691 21.5265 15.2922C21.4035 15.4152 21.2365 15.4844 21.0625 15.4844H7.9375C7.76345 15.4844 7.59653 15.4152 7.47346 15.2922C7.35039 15.1691 7.28125 15.0022 7.28125 14.8281V13.5156C7.28125 13.1675 7.14297 12.8337 6.89683 12.5875C6.65069 12.3414 6.31685 12.2031 5.96875 12.2031C5.62065 12.2031 5.28681 12.3414 5.04067 12.5875C4.79453 12.8337 4.65625 13.1675 4.65625 13.5156V16.1406C4.65625 16.8368 4.93281 17.5045 5.42509 17.9968C5.91738 18.4891 6.58506 18.7656 7.28125 18.7656H21.7188C22.4149 18.7656 23.0826 18.4891 23.5749 17.9968C24.0672 17.5045 24.3437 16.8368 24.3438 16.1406V13.5156C24.3438 13.1675 24.2055 12.8337 23.9593 12.5875C23.7132 12.3414 23.3793 12.2031 23.0312 12.2031Z",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28125 18.7656V20.7344",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7188 18.7656V20.7344",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96875 12.2031C5.96875 11.1588 6.38359 10.1573 7.12202 9.41889C7.86044 8.68047 8.86196 8.26563 9.90625 8.26562H19.0938C20.138 8.26562 21.1396 8.68047 21.878 9.41889C22.6164 10.1573 23.0312 11.1588 23.0312 12.2031",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15.4844V8.26562",
    stroke: "#77838D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofaBed);
export default __webpack_public_path__ + "static/media/sofa_bed.c6433cca.svg";
export { ForwardRef as ReactComponent };